import { SizableText, YStack } from '@mythical/ui'
import usePagination from 'app/hooks/use-pagination'
import { createCollectionListQuery } from 'app/queries/collections/list'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Select } from 'app/components/primitive/Form'
import Spinner from 'app/components/primitive/Spinner'
import { Button, ButtonLink } from 'app/components/primitive/Button'
import CollectionCard from './CollectionCard'
import { Grid } from 'app/components/primitive/Grids'
import Section, { SectionProps } from '../structure/Section'

const query = createCollectionListQuery('Collection', { excludeHidden: true })
const params = {}

const config = {
  formatFn: query.mapToCollectionList,
  limit: 12,
}

const sorts = [
  { label: 'Most Popular', value: '-order' },
  { label: 'Title (A-Z)', value: 'name' },
  { label: 'Title (Z-A)', value: '-name' },
]

type CollectionListProps = {
  wrapperProps?: SectionProps
}

export const CollectionList = observer(
  ({ wrapperProps }: CollectionListProps) => {
    const [sort, setSort] = useState(sorts[0]!.value)

    const { data, loading, error, hasMore, fetchMore, isFetchingNextPage } =
      usePagination(query.query, { ...params, sort }, config)

    const items = data?.docs || []

    return (
      <Section
        title="All Series"
        fs={1}
        fg={1}
        w="100%"
        customCta={
          <Select
            id="sort-series"
            hideLabel
            theme="bgSecondaryOutlined"
            name="seasons-vertical"
            label="Sort by"
            value={sort}
            onValueChange={setSort}
            options={sorts}
            size="$3"
            triggerProps={{ br: '$pill' }}
          />
        }
        {...wrapperProps}
      >
        <Grid
          items={items}
          renderItem={(item) => <CollectionCard {...item} />}
          keyExtractor={(item) => `${item.id}-${item.href}`}
          options={{
            columnGap: 12,
            rowGap: 16,
            numColumns: 2,
            $gtXs: { columnGap: 12, rowGap: 16 },
            $gtSm: { numColumns: 3 },
            $gtLg: { numColumns: 4 },
          }}
        />

        {loading && (
          <YStack fs={1} fg={1} jc="center" ai="center">
            <Spinner size="large" />
          </YStack>
        )}

        {!!error && !loading && (
          <YStack fs={1} fg={1} jc="center" ai="center" gap="$3.5">
            <SizableText
              ff="$heading"
              size="$s"
              $gtSm={{ size: '$m' }}
              ta="center"
              maw={700}
              mx="auto"
            >
              Oops! something's wrong here
            </SizableText>
            <ButtonLink href="/">Reload Homepage</ButtonLink>
          </YStack>
        )}

        {hasMore && (
          <Button
            onPress={fetchMore}
            mx="auto"
            loading={isFetchingNextPage}
            uppercase
          >
            Load More
          </Button>
        )}
      </Section>
    )
  },
)
